import Home from '..'

const RefPage = () => <Home />
export default RefPage
